import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>React Native App Development Company</h1>
              <p>
                Elevate your mobile presence with TekRevol's customized React
                Native mobile application development services. Fuel innovation
                with flexible and effective designs accurately crafted to
                guarantee your app's success in the digital landscape. Maximize
                your ROI with React Native's 38% market share, the preferred
                choice for scalable cross-platform development.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let's Build Your React Native App
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/react-native/banner-react.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
